import type { ColumnDef } from '@tanstack/react-table'
import dayjs from 'dayjs'
import type { ActivityLogItem } from '@/types/api'

interface BuildColumnsOptions {
    pageIndex: number
    pageSize: number
}

export function buildColumns({
    pageIndex,
    pageSize,
}: BuildColumnsOptions): ColumnDef<ActivityLogItem>[] {
    return [
        {
            id: 'stt',
            header: () => <div className="text-center">STT</div>,
            cell: ({ row }) => (
                <div className="text-center">
                    {row.index + 1 + pageIndex * pageSize}
                </div>
            ),
            size: 55,
        },
        {
            accessorKey: 'actionTime',
            header: 'THỜI GIAN',
            cell: ({ getValue }) => {
                const val = getValue() as string
                return val ? dayjs(val).format('DD/MM/YYYY HH:mm') : '-'
            },
            size: 115,
        },
        {
            accessorKey: 'unitName',
            header: 'ĐƠN VỊ',
            size: 160,
        },
        {
            accessorKey: 'robotName',
            header: 'ROBOT',
            cell: ({ getValue }) => {
                const val = getValue() as string
                return (
                    <span className="font-medium text-[#D9704A]">
                        {val || '-'}
                    </span>
                )
            },
        },
        {
            accessorKey: 'actionBy',
            header: 'THỰC HIỆN BỞI',
        },
        {
            accessorKey: 'actionType',
            header: 'THAO TÁC',
            size: 150,
        },
        {
            accessorKey: 'status',
            header: () => <div className="text-center">TRẠNG THÁI</div>,
            cell: ({ getValue }) => {
                const status = getValue() as number
                const isSuccess = status === 1

                return (
                    <div className="text-center">
                        <span
                            className={`inline-block px-4 py-1.5 rounded-full text-xs font-semibold ${isSuccess
                                    ? 'bg-[#EAF7ED] text-[#2FB14F]'
                                    : 'bg-[#FDECEB] text-[#EE4036]'
                                }`}
                        >
                            {isSuccess ? 'Thành công' : 'Thất bại'}
                        </span>
                    </div>
                )
            },
            size: 105,

        },
    ]
}